import { loadable } from '../../../common/utils/lazyLoading';
const OrganisationGroups = loadable(() => import('../OrganisationGroups'));
export default [
    {
        id: 'groups',
        title: 'Organisation Groups',
        route: 'groups',
        icon: 'collaboration',
        component: OrganisationGroups,
        permission: 'organisations_groups',
    },
];
